import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Services } from "./components/Services";
import { Portfolio } from "./components/Portfolio";
import { About } from "./components/About";
import { Testimonials } from "./components/Testimonials";
import { StudiosMap } from "./components/StudiosMap";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { FloatingActions } from "./components/FloatingActions";
import { QuoteDialog } from "./components/QuoteDialog";
import { MeetingDialog } from "./components/MeetingDialog";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import WorkArchive from "./pages/WorkArchive";
import TeamPage from "./pages/TeamPage";

const PublicSite = () => {
    const [quoteOpen, setQuoteOpen] = useState(false);
    const [meetingOpen, setMeetingOpen] = useState(false);

    const openQuote = () => setQuoteOpen(true);
    const openMeeting = () => setMeetingOpen(true);

    return (
        <div className="font-sans bg-[#FAF9F6] text-[#1A1A1A]">
            <Header onQuote={openQuote} onMeeting={openMeeting} />
            <main>
                <Hero onQuote={openQuote} onMeeting={openMeeting} />
                <Marquee />
                <Services onQuote={openQuote} />
                <Portfolio onQuote={openQuote} />
                <About />
                <Testimonials />
                <StudiosMap />
                <Contact onQuote={openQuote} onMeeting={openMeeting} />
            </main>
            <Footer />
            <FloatingActions />

            <QuoteDialog open={quoteOpen} onOpenChange={setQuoteOpen} />
            <MeetingDialog open={meetingOpen} onOpenChange={setMeetingOpen} />
        </div>
    );
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<PublicSite />} />
                    <Route path="/work" element={<WorkArchive />} />
                    <Route path="/team" element={<TeamPage />} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin" element={<AdminDashboard />} />
                </Routes>
            </BrowserRouter>

            <Toaster
                position="bottom-center"
                toastOptions={{
                    style: {
                        background: "#1A1A1A",
                        color: "#FAF9F6",
                        border: "1px solid rgba(250,249,246,0.1)",
                        borderRadius: 0,
                        fontFamily: "Manrope, sans-serif",
                    },
                }}
            />
        </div>
    );
}

export default App;
